exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".option-btn[data-v-293b6f30]{padding:10px 18px;border-radius:99px;border:1px solid var(--fts-primary);background:transparent;cursor:pointer;font-size:14px;transition:.2s;color:var(--fts-primary)}.option-btn[data-v-293b6f30]:hover{background:var(--fts-primary);color:#fff}", ""]);

// exports
